$(document).ready(() => {
    window.addEventListener(
        "message",
        (event) => {
            try {
                const messages = JSON.parse(event.data);

                messages.forEach(element => {
                    if (element.type === 'scrollToTop') {
                        setTimeout(function() {
                            window.scrollTo(0, 0);
                        }, 500);
                    } else if (element.type === 'gtmEvent') {
                        const detail = JSON.parse(element.detail);
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push(detail);
                    }
                });
            } catch(ignore) {}
        },
        false,
    );
});